export default {"src":"/_next/static/media/rise.1d887efe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};